export interface BatchExpiredUserListRequest {
  userRegistrationDateFrom: string
  userRegistrationDateTo: string
  userExpirationDateFrom: string
  userExpirationDateTo: string
  userRegistrationBranchCode: string
  order: string
  userType: string
  outputStatistics: boolean
  batchType: string
}

export function BatchExpiredUserListRequestToJSON(
  value: BatchExpiredUserListRequest
): any {
  return {
    user_registration_date_from: value.userRegistrationDateFrom,
    user_registration_date_to: value.userRegistrationDateTo,
    user_expiration_date_from: value.userExpirationDateFrom,
    user_expiration_date_to: value.userExpirationDateTo,
    user_registration_branch_code: value.userRegistrationBranchCode,
    order: value.order,
    user_type: value.userType,
    output_statistics: value.outputStatistics,
    batch_type: value.batchType
  }
}
